class DatatableSearchDelay {
    constructor(datatable, input) {
        let searchWait = 0;
        let searchWaitInterval;
        $(input)
            .unbind() // leave empty here
            .bind('input', function(e){ //leave input
                const item = $(this);
                searchWait = 0;
                if(!searchWaitInterval) searchWaitInterval = setInterval(function(){
                    if(searchWait >= 4){
                        clearInterval(searchWaitInterval);
                        searchWaitInterval = '';
                        let searchTerm = $(item).val();
                        if(datatable.settings()[0].jqXHR){
                            datatable.settings()[0].jqXHR.abort(); // cancel previous request
                        }
                        datatable.search(searchTerm).draw(); // change to new api
                        searchWait = 0;
                    }
                    searchWait++;
                }, 200);
            });
    }
}
window.DatatableSearchDelay = DatatableSearchDelay;